import React from 'react';
import { TableCell, TableRow, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

function MemebershipPerkTableRow({ membershipPerk, confirmDeleleteMembershipPerk }) {
  return (
    <>
      <TableRow>
        <TableCell>{membershipPerk.title}</TableCell>
        <TableCell>
          <img src={membershipPerk.image_url} width="150px" />
        </TableCell>
        <TableCell>{membershipPerk.tier.join(', ')}</TableCell>
        <TableCell>{membershipPerk.description}</TableCell>
        <TableCell>
          <Link textDecoration={'none'} to={`/membership-perks/edit/${membershipPerk.id}`}>
            <Button>Edit</Button>
          </Link>
          <Button onClick={() => confirmDeleleteMembershipPerk(membershipPerk.id)}>Delete</Button>
        </TableCell>
      </TableRow>
    </>
  );
}

export default MemebershipPerkTableRow;
